import { loadPermissionsForUser } from '@/libraries/api/auth'

export const entitlementsModule = {
  namespaced: true,
  state: {
    entitlementsByDomain: {},
    currentService: undefined,
  },
  getters: {
    canAccessService: (state, commit, rootState, rootGetters) => {
      return service => {
        const domainUUID = rootGetters.currentDomainUUID
        const domainExistsLocally = domainUUID && (domainUUID in state.entitlementsByDomain)
        const entitledToAccessForCurrentDomain = domainExistsLocally && (service in state.entitlementsByDomain[domainUUID])
        return entitledToAccessForCurrentDomain
      }
    },
    canPerformOperationForCurrentService: (state, commit, rootState, rootGetters) => {
      return operation => {
        console.log(`canPerformOperationForCurrentService: ${state.currentService}.${operation} for ${rootGetters.currentDomainUUID}`)
        const domainUUID = rootGetters.currentDomainUUID
        if (domainUUID && (domainUUID in state.entitlementsByDomain)) {
          if (state.currentService in state.entitlementsByDomain[domainUUID]) {
            return state.entitlementsByDomain[domainUUID][state.currentService].includes(operation)
          }
        }
        // if both above eval to true, default return false
        return false
      }
    },
    /**
     * Determines if the user is permitted to access an operation for a particular service.
     *
     * @param {String} operation The key for the operation.
     * @param {String} service The key for the service.
     * @returns Boolean, indicating if the user has access.
     */
    canPerformOperationForService: (state, commit, rootState, rootGetters) => {
      return (service, operation) => {
        const domainUUID = rootGetters.currentDomainUUID
        console.log(`canPerformOperationForService: ${service}.${operation} for ${domainUUID}`)

        if (domainUUID && (domainUUID in state.entitlementsByDomain)) {
          if (service in state.entitlementsByDomain[domainUUID]) {
            return state.entitlementsByDomain[domainUUID][service].includes(operation)
          }
        }
        // if both above eval to true, default return false
        return false
      }
    },
    entitlementsForDomainUUID: (state, getters) => {
      return domainUUID => {
        return state.entitlementsByDomain[domainUUID]
      }
    },
    currentDomainEntitlements: (state, getters, rootState, rootGetters) => {
      const domainUUID = rootGetters.currentDomainUUID
      const domainEntitlements = getters.entitlementsForDomainUUID(domainUUID)

      return domainEntitlements
    },
  },
  actions: {
    loadPermissionsForUser: (context, userID) => {
      context.commit('incrementRequestCountForServiceNamed', 'entitlements', { root: true })
      return loadPermissionsForUser(userID).then(data => {
        console.log(`loaded ${data.entitlementsByDomain}`)
        context.commit('setUserPermissions', data.entitlementsByDomain)
        context.commit('decrementRequestCountForServiceNamed', 'entitlements', { root: true })
      }).catch(error => {
        console.error('entitlements.js', error)
        context.commit('decrementRequestCountForServiceNamed', 'entitlements', { root: true })
      })
    },
    clearEntitlements ({ state, commit }) {
      commit('clearPermissions')
    },
  },
  mutations: {
    clearEntitlements: (context) => {
      context.state = {
        entitlementsByDomain: {},
        currentService: undefined,
      }
    },
    setUserPermissions: (state, entitlements) => {
      state.entitlementsByDomain = entitlements
    },
    setCurrentService: (state, service) => {
      state.currentService = service
    },
  },
}
